import React from 'react';
import { personalInfo } from '../mock';
import { Scale, Award, BookOpen, Download } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const About = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const highlights = [
    {
      icon: <Scale className="w-8 h-8" />,
      title: t.about.experience,
      description: t.about.experienceDesc
    },
    {
      icon: <Award className="w-8 h-8" />,
      title: t.about.international,
      description: t.about.internationalDesc
    },
    {
      icon: <BookOpen className="w-8 h-8" />,
      title: t.about.academic,
      description: t.about.academicDesc
    }
  ];

  // CV doğrudan indirme linki olarak kullanılacak

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-4">
            {t.about.title}
          </h2>
          <div className="w-24 h-1 bg-gray-900 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {highlights.map((item, index) => (
            <div
              key={index}
              className="text-center p-8 border border-gray-200 hover:border-gray-400 transition-all duration-300 hover:shadow-lg"
            >
              <div className="flex justify-center mb-4 text-gray-900">
                {item.icon}
              </div>
              <h3 className="text-xl font-serif font-semibold text-gray-900 mb-2">
                {item.title}
              </h3>
              <p className="text-gray-600">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto space-y-6">
          {t.about.bio.map((paragraph, index) => (
            <p key={index} className="text-lg text-gray-700 leading-relaxed text-justify">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href={personalInfo.cvLink}
              download
              className="inline-flex items-center gap-2 bg-gray-900 text-white px-8 py-4 font-medium hover:bg-gray-800 transition-all duration-300 shadow-md hover:shadow-lg"
            >
              {t.about.downloadCV}
              <Download className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
